import { StationPageWrapper } from '@app/core/routing/StationPageWrapper';
import { LivePlayerPage } from './screens/LivePlayerPage';

export function LivePlayerAdapterPage() {
  return (
    <StationPageWrapper>
      <LivePlayerPage />
    </StationPageWrapper>
  );
}
